import { render, staticRenderFns } from "./ScheduleDefaultPeriod.vue?vue&type=template&id=72f32b30&scoped=true"
import script from "./ScheduleDefaultPeriod.vue?vue&type=script&lang=js"
export * from "./ScheduleDefaultPeriod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f32b30",
  null
  
)

export default component.exports